import { SelfDescription } from "./describeSelf";

enum WhyConsistency {
  Time = 'Time',
  Motivation = 'Motivation',
  Injuries = 'Injuries',
  ProgramHopping  = 'ProgramHopping',
};

const whyConsistencyQuestion = {
  visibleIf: `{describeSelf} == "${SelfDescription.StruggleConsistency}"`,
  name: 'whyConsistency',
  title: 'What is affecting your consistency most?',
  description: 'Helps us understand how we can help.',
  type: 'radiogroup',
  choices: [
    {
      value: WhyConsistency.Time,
      text: 'Lack of time, other commitments',
    }, {
      value: WhyConsistency.Motivation,
      text: 'Lack of motivation, hitting plateaus',
    }, {
      value: WhyConsistency.Injuries,
      text: 'Injuries limit what I can do',
    }, {
      value: WhyConsistency.ProgramHopping,
      text: 'I switch programs a lot',
    }
  ],
  isRequired: true,
  // showOtherItem: true,
};

export {
  WhyConsistency,
  whyConsistencyQuestion,
}